














































































/** @format */
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { IFieldInfoListItem } from '@/types/component';
import ShowImg from '@/components/show-img/index.vue';
import { orderSpecialExamine } from '@/api/exception-management/index';
@Component({
  name: 'HandDetail',
  components: { ShowImg }
})
export default class HandDetail extends Vue {
  // 是否审核
  @Prop({ type: Boolean, default: false })
  isReview!: boolean;
  // 数据
  @Prop({ type: Object, default: {} })
  formData!: Record<string, any>;
  // 是否展示弹窗
  @Prop({ type: Boolean, default: false })
  visible!: boolean;
  reviewDescription = '';
  formFields = [
    {
      prop: 'parkName',
      label: '车场名称'
    },
    {
      prop: 'plate',
      label: '车牌号'
    },
    {
      prop: 'enterChannelName',
      label: '入口通道'
    },
    {
      prop: 'enterTime',
      label: '入场时间'
    },
    {
      prop: 'exitChannelName',
      label: '出口通道'
    },
    {
      prop: 'exitTime',
      label: '出场时间'
    },
    {
      prop: 'releaseCauseName',
      label: '放行原因'
    },
    {
      prop: 'operater',
      label: '操作人'
    },
    {
      prop: 'pkOrderId',
      label: '停车订单号'
    }
  ];
  formReviewFields = [
    {
      prop: 'reviewStatusName',
      label: '审核状态'
    },
    {
      prop: 'reviewTime',
      label: '审核时间'
    },
    {
      prop: 'reviewDescription',
      label: '审核意见'
    },
    {
      prop: 'reviewer',
      label: '审核人'
    }
  ];
  formFeeFields = [
    {
      prop: 'totalAmount',
      label: '应收金额'
    },
    {
      prop: 'paidAmount',
      label: '实收金额'
    },
    {
      prop: 'discountAmount',
      label: '优惠金额'
    },
    {
      prop: 'unpaidAmount',
      label: '应收未收'
    },
    {
      prop: 'cancelAmount',
      label: '减免金额'
    }
  ];
  loadingFlag: boolean = false;
  //
  onSubmit() {
    if (this.isReview) {
      const json = {
        parkId: this.formData.parkId,
        reviewDescription: this.reviewDescription,
        reviewStatus: '01',
        orderId: this.formData.pkOrderId
      };
      this.reviewItem(json);
    } else {
      this.$emit('cancel');
    }
  }
  //
  cacnelItem() {
    if (this.isReview) {
      const json = {
        parkId: this.formData.parkId,
        reviewDescription: this.reviewDescription,
        reviewStatus: '00',
        orderId: this.formData.pkOrderId
      };
      this.reviewItem(json);
    } else {
      this.$emit('cancel');
    }
  }
  onCancel() {
    this.$emit('cancel');
  }
  //审核
  async reviewItem(json: { parkId: any; reviewDescription: string; reviewStatus: string; orderId: any }) {
    try {
      if (this.loadingFlag) return;
      this.loadingFlag = true;
      await orderSpecialExamine(json);
      this.$message.success('意见提交成功');
      this.$emit('create');
    } catch (e) {
      this.$message.error(e.msg || '系统繁忙请稍后再试');
    } finally {
      this.loadingFlag = false;
    }
  }
}
